var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_3079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2913 8.69C29.1735 8.22919 28.9478 7.80298 28.6329 7.44654C28.318 7.09011 27.9228 6.81366 27.48 6.64C23.195 4.985 16.375 5 16 5C15.625 5 8.805 4.985 4.52 6.64C4.0772 6.81366 3.68204 7.09011 3.36712 7.44654C3.05219 7.80298 2.82653 8.22919 2.70875 8.69C2.385 9.9375 2 12.2175 2 16C2 19.7825 2.385 22.0625 2.70875 23.31C2.82636 23.771 3.05194 24.1975 3.36687 24.5542C3.68181 24.9108 4.07706 25.1875 4.52 25.3613C8.625 26.945 15.05 27 15.9175 27H16.0825C16.95 27 23.3787 26.945 27.48 25.3613C27.9229 25.1875 28.3182 24.9108 28.6331 24.5542C28.9481 24.1975 29.1736 23.771 29.2913 23.31C29.615 22.06 30 19.7825 30 16C30 12.2175 29.615 9.9375 29.2913 8.69ZM20.2775 16.4163L14.2775 20.4163C14.2022 20.4665 14.1146 20.4954 14.0242 20.4997C13.9338 20.5041 13.8438 20.4839 13.764 20.4411C13.6842 20.3984 13.6175 20.3348 13.571 20.2571C13.5245 20.1794 13.4999 20.0905 13.5 20V12C13.4999 11.9095 13.5245 11.8206 13.571 11.7429C13.6175 11.6652 13.6842 11.6016 13.764 11.5589C13.8438 11.5161 13.9338 11.4959 14.0242 11.5003C14.1146 11.5046 14.2022 11.5335 14.2775 11.5838L20.2775 15.5838C20.3461 15.6294 20.4023 15.6913 20.4412 15.7639C20.4801 15.8365 20.5005 15.9176 20.5005 16C20.5005 16.0824 20.4801 16.1635 20.4412 16.2361C20.4023 16.3087 20.3461 16.3706 20.2775 16.4163Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_3079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIconBlack);
export default __webpack_public_path__ + "static/media/yt_icon_black.15cb5f464376d59408ad2abf9d97a207.svg";
export { ForwardRef as ReactComponent };